import React, {useState, useLayoutEffect, useEffect}  from "react";
import { StyledHero } from "./heroComponents";
import HeroMobile from "./heroMobile";
import HeroPc from "./heroPc";

const Hero = (props) => {

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    if(typeof window !== "undefined"){

      console.log("width inicial ",window.screen.width);
      console.log("height inicial ",window.screen.height);
      if(window.screen.width < 768){
          setIsMobile(true);
        }else{
          setIsMobile(false);
        }
    }
  },[]); 



  useLayoutEffect(() => {

    if(typeof window !== "undefined"){

      const updateSize = () => {

        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        console.log("resize ",window.screen.width);
        if(window.screen.width < 1024){
          setIsMobile(true);
        }else{
          setIsMobile(false);
        }
      };

      window.addEventListener("resize",updateSize);
    }
  }, []);

  return (
    <StyledHero landscape={height < width ? true : false}>

       {isMobile === true || height > width  ? <HeroMobile {...props}></HeroMobile> : <HeroPc {...props}></HeroPc>}
      
    </StyledHero>
  );
};

export default Hero;
